(function () {
  function initJuoCustom() {
    const container = document.querySelector('.juo-custom-widget');
    if (!container) return;
    const productId = container.dataset.productId;
    if (!productId) return;
    const productForm = document.querySelector('form[action$="/cart/add"]');
    if (!productForm) return;
    if (!productForm.hasAttribute('is')) {
      productForm.setAttribute('is', 'product-form');
    }

    function queryParamVariant() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('variant') || productForm.querySelector('input[name="id"]')?.value;
    }

    function updateVariant(providedVariant = null) {
      let currentVariantId = queryParamVariant();
      // If a variant object was provided (e.g. from variant:change event detail), use its ID
      if (providedVariant && providedVariant.id) {
        currentVariantId = providedVariant.id;
      }

      const mode = (otpRadio && otpRadio.checked) ? 'otp' : 'subscription';
      const activeBtn = container.querySelector('.juo-custom-btn.active');
      let months = 1;
      if (activeBtn) {
        months = parseInt(activeBtn.dataset.months);
        if (isNaN(months)) months = parseInt(activeBtn.dataset.index);
      }
      
      updateSelection(mode, months, false, currentVariantId);
    }

    const qtyInput = document.querySelector('.quantity-selector__input[name="quantity"]');
    const sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
    const frequencyWrapper = container.querySelector('.juo-frequency-wrapper');
    const btns = container.querySelectorAll('.juo-custom-btn');
    const selectionBlocks = container.querySelectorAll('.juo-selection-block');
    const otpRadio = container.querySelector('input[name="juo-mode"][value="otp"]');
    const widgetDataEl = document.getElementById('juo-subscription-widget-data');
    const comparePricesEl = document.getElementById('juo-variant-compare-at-prices');
    if (!widgetDataEl || !comparePricesEl) return;

    let variantsData, currencyFormat, variantComparePrices;
    try {
      const fullData = JSON.parse(widgetDataEl.textContent);
      variantsData = fullData[0];
      currencyFormat = fullData[2] || container.dataset.currencyFormat || "€__AMOUNT__";
      variantComparePrices = JSON.parse(comparePricesEl.textContent);
    } catch (e) {
      return;
    }

    function formatMoney(cents) {
      let amount = (cents / 100).toFixed(2);
      if (currencyFormat.includes('amount_with_comma_separator') || currencyFormat.includes('__AMOUNT__')) {
        amount = amount.replace('.', ',');
      }
      return currencyFormat.replace(/\{\{\s*amount.*\s*\}\}/g, amount).replace('__AMOUNT__', amount);
    }

    function updatePriceDisplay(variant, planId, currentMode) {
      const priceList = document.querySelector('.product-info__price.umain-product price-list.price-list--lg');
      // if (!priceList) return; // Removed for now to allow widget updates even if main price is not found
      const salePriceEl = priceList ? priceList.querySelector('sale-price') : null;
      const comparePriceEl = priceList ? priceList.querySelector('compare-at-price') : null;
      
      let otpPrice = variant.price;
      let baseComparePrice = variantComparePrices[variant.id] || variant.price;
      
      let price = variant.price;
      let comparePrice = baseComparePrice;
      let quantity = parseInt(qtyInput ? qtyInput.value : 1);

      // Subscription Prices
      const subPriceEl = container.querySelector('[data-sub-price]');
      const subComparePriceEl = container.querySelector('[data-sub-compare-price]');
      const otpPriceEl = container.querySelector('[data-otp-price]');

      // Find lowest subscription price for the variant
      let lowestSubPrice = variant.price;
      if (variant.sellingPlans && variant.sellingPlans.length > 0) {
        lowestSubPrice = Math.min(...variant.sellingPlans.map(p => p.price));
      }

      if (subPriceEl) subPriceEl.textContent = formatMoney(lowestSubPrice);
      if (subComparePriceEl) subComparePriceEl.textContent = formatMoney(baseComparePrice);
      if (otpPriceEl) otpPriceEl.textContent = formatMoney(otpPrice);

      if (planId) {
        const plan = variant.sellingPlans.find(p => String(p.id) === String(planId));
        if (plan) {
          price = plan.price;
          comparePrice = (plan.comparePrice || variant.price) + (baseComparePrice - variant.price);
        }
      }

      const totalPrice = price * quantity;
      const totalComparePrice = comparePrice * quantity;

      if (salePriceEl) {
        salePriceEl.innerHTML = `<span class="sr-only">Verkoopprijs</span>${formatMoney(totalPrice)}`;
      }
      if (comparePriceEl) {
        if (totalComparePrice > totalPrice) {
          comparePriceEl.style.display = '';
          comparePriceEl.innerHTML = `<span class="sr-only">Normale prijs</span>${formatMoney(totalComparePrice)}`;
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      // Update plan prices in buttons
      btns.forEach(btn => {
        const btnMonths = parseInt(btn.dataset.months);
        const pName = btnMonths === 1 ? '1 Maand' : (btnMonths === 2 ? '2 Maanden' : '3 Maanden');
        const plan = variant.sellingPlans.find(p => p.name.includes(pName));
        const pPriceEl = btn.querySelector('[data-plan-price]');
        if (pPriceEl && plan) {
          pPriceEl.textContent = formatMoney(plan.price);
        }
      });

      // Update variant swatches prices
      const activeBtn = container.querySelector('.juo-custom-btn.active');
      let months = 0;
      if (activeBtn) {
        months = parseInt(activeBtn.dataset.months);
        if (isNaN(months)) months = parseInt(activeBtn.dataset.index);
      }
      const planNamePrefix = months === 1 ? '1 Maand' : (months === 2 ? '2 Maanden' : (months === 3 ? '3 Maanden' : ''));

      document.querySelectorAll('.block-swatch__variant-price[data-variant-id]').forEach(priceEl => {
        const vId = priceEl.dataset.variantId;
        const vData = variantsData.find(v => String(v.id) === String(vId));
        if (!vData) return;

        let vPrice = vData.price;
        if (currentMode === 'subscription' && planNamePrefix) {
          const vPlan = vData.sellingPlans.find(p => p.name.includes(planNamePrefix));
          if (vPlan) {
            vPrice = vPlan.price;
          }
        }
        priceEl.textContent = formatMoney(vPrice);
      });

      // Update price per zakje (unit price)
      document.querySelectorAll('.block-swatch__per-unit').forEach(unitPriceEl => {
        const otpPrice = unitPriceEl.dataset.otpPricePerUnit;
        const subPrice = unitPriceEl.dataset.subPricePerUnit;
        const valueEl = unitPriceEl.querySelector('.block-swatch__unit-price-value');

        if (currentMode === 'subscription' && subPrice) {
          if (valueEl) valueEl.textContent = subPrice;
          else unitPriceEl.childNodes[0].textContent = subPrice;
        } else if (otpPrice) {
          if (valueEl) valueEl.textContent = otpPrice;
          else unitPriceEl.childNodes[0].textContent = otpPrice;
        }
      });

      // Update sale badge
      const saleBadge = document.querySelector('.badge--on-sale');
      if (saleBadge) {
        if (totalComparePrice > totalPrice) {
          const savingsPercent = Math.round((totalComparePrice - totalPrice) / totalComparePrice * 100);
          saleBadge.textContent = `Bespaar ${savingsPercent}%`;
          saleBadge.style.display = '';
        } else {
          saleBadge.style.display = 'none';
        }
      }
    }

    function updateUIFromJuo() {
      const juoWidget = document.getElementById('juo-subscription-widget');
      if (!juoWidget) return;
      const juoOtpRadio = juoWidget.querySelector('input[value="otp"]');
      const juoSelect = juoWidget.querySelector('select[data-ref="selling-plan"]');
      if (juoOtpRadio && juoOtpRadio.checked) {
        updateSelection('otp', null, false);
      } else if (juoSelect) {
        const planId = juoSelect.value;
        const variantIdInput = productForm.querySelector('input[name="id"]');
        const variantId = variantIdInput ? variantIdInput.value : null;
        const variant = variantsData.find(v => String(v.id) === String(variantId));
        if (variant) {
          const plan = variant.sellingPlans.find(p => String(p.id) === String(planId));
          if (plan) {
            let months = 1;
            if (plan.name.includes('3')) months = 3;
            else if (plan.name.includes('2')) months = 2;
            updateSelection('subscription', months, false);
          }
        }
      }
    }

    function updateSelection(mode, months, updateQty = true, providedVariantId = null) {
      const variantId = providedVariantId || queryParamVariant();
      const variant = variantsData.find(v => String(v.id) === String(variantId));
      if (!variant) return;

      let planId = '';
      const juoWidget = document.getElementById('juo-subscription-widget');

      selectionBlocks.forEach(block => {
        block.classList.toggle('active', block.dataset.mode === mode);
      });

      if (mode === 'subscription') {
        if (frequencyWrapper) frequencyWrapper.style.display = '';
        if (otpRadio) otpRadio.checked = false;
        btns.forEach(b => {
          let bMonths = parseInt(b.dataset.months);
          if (isNaN(bMonths)) bMonths = parseInt(b.dataset.index);
          b.classList.toggle('active', bMonths === months);
        });
        
        const planName = months === 1 ? '1 Maand' : (months === 2 ? '2 Maanden' : '3 Maanden');
        const plan = variant.sellingPlans.find(p => p.name.includes(planName));
        if (plan) {
          planId = plan.id;
        }

        if (updateQty && qtyInput) {
          qtyInput.value = months;
          qtyInput.dispatchEvent(new Event('change', {bubbles: true}));
        }

        if (juoWidget) {
          const juoSubRadio = juoWidget.querySelector('input[value="subscription"]');
          if (juoSubRadio) {
            juoSubRadio.checked = true;
            juoSubRadio.dispatchEvent(new CustomEvent('change', {bubbles: true, detail: {fromCustomWidget: true}}));
          }
          const juoSelect = juoWidget.querySelector('select[data-ref="selling-plan"]');
          if (juoSelect && planId) {
            juoSelect.value = planId;
            juoSelect.dispatchEvent(new CustomEvent('change', {bubbles: true, detail: {fromCustomWidget: true}}));
          }
        }
      } else {
        if (frequencyWrapper) frequencyWrapper.style.display = 'none';
        if (otpRadio) otpRadio.checked = true;
        planId = '';
        
        // Remove active state from frequency buttons when OTP is selected
        btns.forEach(b => b.classList.remove('active'));

        if (juoWidget) {
          const juoOtpRadio = juoWidget.querySelector('input[value="otp"]');
          if (juoOtpRadio) {
            juoOtpRadio.checked = true;
            juoOtpRadio.dispatchEvent(new CustomEvent('change', {bubbles: true, detail: {fromCustomWidget: true}}));
          }
        }
      }

      if (sellingPlanInput) {
        sellingPlanInput.value = planId;
        sellingPlanInput.dispatchEvent(new Event('change', {bubbles: true}));
      }
      updatePriceDisplay(variant, planId, mode);
    }

    btns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        let months = parseInt(btn.dataset.months);
        if (isNaN(months)) months = parseInt(btn.dataset.index);
        updateSelection('subscription', months);
      });
    });

    selectionBlocks.forEach(block => {
      block.addEventListener('click', (e) => {
        const mode = block.dataset.mode;
        if (mode === 'subscription') {
          const activeBtn = container.querySelector('.juo-custom-btn.active');
          let months = 1;
          if (activeBtn) {
            months = parseInt(activeBtn.dataset.months);
            if (isNaN(months)) months = parseInt(activeBtn.dataset.index);
          }
          updateSelection('subscription', months);
        } else {
          updateSelection('otp');
        }
      });
    });

    if (otpRadio) {
      otpRadio.addEventListener('change', () => {
        if (otpRadio.checked) updateSelection('otp');
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', () => {
        const qty = parseInt(qtyInput.value);
        if (otpRadio && otpRadio.checked) {
          const variantIdInput = productForm.querySelector('input[name="id"]');
          const variant = variantsData.find(v => String(v.id) === String(variantIdInput?.value));
          if (variant) updatePriceDisplay(variant, '', 'otp');
          return;
        }
        let months = 1;
        if (qty >= 3) months = 3;
        else if (qty === 2) months = 2;
        updateSelection('subscription', months, false);
      });
    }

    // We keep this as a fallback but avoid re-triggering for the same form
    document.addEventListener('variant:change', (e) => {
      if (e.target === productForm) return;
      let variant = e.detail.variant;
      updateVariant(variant);
    });

    const juoWidget = document.getElementById('juo-subscription-widget');
    if (juoWidget) {
      juoWidget.addEventListener('change', (e) => {
        if (!e.detail || !e.detail.fromCustomWidget) {
          updateUIFromJuo();
        }
      });
    }
    updateSelection('subscription', 1, true, queryParamVariant());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initJuoCustom);
  } else {
    initJuoCustom();
  }
})();
